import { render, staticRenderFns } from "./coderProReviewPage.vue?vue&type=template&id=193f3948&scoped=true&"
import script from "./coderProReviewPage.vue?vue&type=script&lang=js&"
export * from "./coderProReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./coderProReviewPage.vue?vue&type=style&index=0&id=193f3948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193f3948",
  null
  
)

export default component.exports